document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".coupon-lineup-item");

  items.forEach(item => {
    const link = item.closest("a");

    item.addEventListener("click", function (e) {
      e.preventDefault();

      const discount = item.querySelector(".coupon-lineup-item-txt-discount");
      const deadline = item.querySelector(".coupon-lineup-item-txt-deadline");
      const against = item.querySelector(".coupon-lineup-item-txt-against");

      if (discount) discount.remove();

      if (against) {
        against.textContent = "クーポンを取得しました✅";
        against.style.display = "block";
      }

      if (deadline) {
        deadline.textContent =  "商品ページに移動します";
        deadline.style.display = "block";
      }

      setTimeout(() => {
        if (link) {
          window.location.href = link.href;
        }
      }, 800);
    });
  });
});